import { getCalculatedConstitution } from './banyan-quiz-storage.js';

class ProfileLink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const customerIsLoggedIn = this.getAttribute('data-customer-is-logged-in') !== 'false';
    const serverConstitution = this.getAttribute('data-server-quiz-data');
    const serverQuizLastUpdated = this.getAttribute('data-server-quiz-last-updated');
    const assetsUrl = this.getAttribute('data-assets-url');
    const quizLandingUrl = this.getAttribute('data-quiz-landing-url');
    const quizLinkClasses = this.getAttribute('data-quiz-link-classes');
    const profileLinkClasses = this.getAttribute('data-profile-link-classes');
    const profileLinkImageClasses = this.getAttribute('data-profile-link-image-classes');
    const idPrefix = this.getAttribute('data-id-prefix');
    const localConstitution = getCalculatedConstitution();
    const localQuizLastUpdated = this.getQuizLastUpdated();
    const dosha = localQuizLastUpdated > serverQuizLastUpdated ? localConstitution : serverConstitution;

    const wrapper = document.createElement('div');

    wrapper.innerHTML = customerIsLoggedIn && dosha
      ? this.buildProfileLink(dosha, assetsUrl, profileLinkClasses, profileLinkImageClasses, idPrefix)
      : this.buildQuizLink(quizLandingUrl, quizLinkClasses, idPrefix);

    this.appendChild(wrapper);
  }

  buildProfileLink(dosha, assetsUrl, profileLinkClasses, profileLinkImageClasses, idPrefix) {
    const doshas = dosha?.split('_');
    let doshaIcons = '';
    for (dosha of doshas) {
     let doshaFirstLetter = dosha.charAt(0); 
     doshaIcons += `<span class="${dosha}">${doshaFirstLetter}</span>`; 
    }

    return `
      <a id="${idPrefix}profile-link" class="${profileLinkClasses}" href="/pages/profile-results">
        ${doshaIcons}
        <span>My Ayurvedic Profile&trade;</span>
      </a>
    `;
  }

  buildQuizLink(quizLandingUrl, quizLinkClasses, idPrefix) {
    return `
      <a id="${idPrefix}dosha-quiz"
        aria-label="Discover Your Doesha. Take the quiz"
        href="${quizLandingUrl}"
        class="${quizLinkClasses}">
        <span>Discover Your Dosha</span>
      </a>
    `;
  }

  getQuizLastUpdated(){
    let localQuizData = window.localStorage.getItem('quizData');
    if(!localQuizData){
      return null;
    }
    localQuizData = JSON.parse(localQuizData);
    if(!localQuizData['quizLastUpdated']){
      return null;
    }
    return parseInt(localQuizData['quizLastUpdated']);
  }
}

customElements.define('profile-link', ProfileLink);
